
const CHUNK_RELOAD_KEY = 'mikro_error_page_reload'
const CHUNK_RELOAD_MAX = 1
const CHUNK_RELOAD_TTL_MS = 30000

function isChunkError(error) {
  if (!error) return false
  const message = error.message || ''
  return (
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes('ChunkLoadError') ||
    message.includes('dynamically imported module')
  )
}

export default {
  layout: 'default',
  props: {
    error: {
      type: Object,
      default: () => ({
        statusCode: 500,
        message: 'error',
      }),
    },
  },
  data() {
    return {
      isAutoReloading: false,
    }
  },
  mounted() {
    this.logClientError()
    this.attemptAutoRecovery()
  },
  methods: {
    logClientError() {
      if (typeof window === 'undefined') return
      const payload = {
        statusCode: this.error.statusCode,
        message: this.error.message || '',
        url: window.location.href,
        referrer: document.referrer || '',
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
        isChunk: isChunkError(this.error),
      }
      console.error('[error-page]', JSON.stringify(payload))
    },

    attemptAutoRecovery() {
      if (typeof window === 'undefined') return
      if (this.error.statusCode !== 500) return
      if (!isChunkError(this.error)) return

      try {
        const raw = sessionStorage.getItem(CHUNK_RELOAD_KEY)
        let count = 0
        if (raw) {
          const parsed = JSON.parse(raw)
          if (Date.now() - parsed.ts < CHUNK_RELOAD_TTL_MS) {
            count = parsed.count || 0
          }
        }
        if (count >= CHUNK_RELOAD_MAX) {
          sessionStorage.removeItem(CHUNK_RELOAD_KEY)
          return
        }
        sessionStorage.setItem(
          CHUNK_RELOAD_KEY,
          JSON.stringify({ count: count + 1, ts: Date.now() })
        )
      } catch {
        return
      }

      this.isAutoReloading = true
      window.location.reload(true)
    },
  },
}
